import { lazy } from 'react';

const CharitySirenRnaRoute = lazy(
  () => import('../components/steps/charity-siren-rna-step/CharitySirenRna'),
);

export default CharitySirenRnaRoute;
